import * as React from 'react';
import MuiList from '@mui/material/List';

interface IProps {
  children: React.ReactNode;
}

const EDLinkList = (props: IProps) => (
  <MuiList disablePadding sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    {props.children}
  </MuiList>
);

export default EDLinkList;
